import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageComponent } from '../../components/page/page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FieldContainerDirective } from 'src/app/general/directives/field/field-container.directive';
import { FieldDirective } from 'src/app/general/directives/field/field.directive';
import { FormService } from 'src/app/general/services/form.service';
import { SessionService } from '../../services/session.service';
import { ActionComponent } from 'src/app/general/components/action/action.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TitleComponent } from 'src/app/general/components/title/title.component';
import { OrdersModel } from '../../components/orders/orders-model';
import { DeviceOrdersModel } from '../../components/orders/device-orders-model';
import { BackendService } from '../../services/backend.service';
import { OrdersComponent } from '../../components/orders/orders.component';
import { AuthenticationStatus } from '../../util/util';
import { RouteUtil } from 'src/app/general/util/route-util';
import { Util } from 'src/app/general/util/util';
import { ActivatedRoute } from '@angular/router';
import { DeviceHeaderComponent } from '../../components/device-header/device-header.component';

@Component({
  selector: 'app-device-orders-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    TitleComponent,
    TranslateModule,
    FieldContainerDirective,
    FieldDirective,
    ActionComponent,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    OrdersComponent,
    DeviceHeaderComponent
  ],
  templateUrl: './device-orders-page.component.html',
  styleUrls: ['./device-orders-page.component.css']
})
export class DeviceOrdersPageComponent implements OnInit {

  deviceId: string;

  odersModel: OrdersModel;

  constructor(
      public formService: FormService,
      public sessionService: SessionService,
      private backendService: BackendService,
      private activatedRoute: ActivatedRoute) {
    this.deviceId = '';
    this.odersModel = new DeviceOrdersModel('', this.backendService);
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }

    const pathParams = RouteUtil.getPathParams(this.activatedRoute);
    this.deviceId = Util.safeString(pathParams.get('deviceId'));
    this.odersModel = new DeviceOrdersModel(this.deviceId, this.backendService);
  }
}
